import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  AppFormikDatePicker,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import NoAuditCard from './NoAuditCard';
import useSize from 'shared/components/Hooks';

const AuditLogFilterList = (): ReactElement => {
  const [decision, setDecision] = useState('');
  const [type, setType] = useState('');
  const [server, setServer] = useState('');
  const { isDesktop } = useSize();

  return (
    <>
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        spacing={3}
        alignItems="center"
      >
        <FormControl fullWidth size="small">
          <Select
            displayEmpty
            value={decision}
            onChange={(e) => setDecision(e.target.value)}
          >
            <MenuItem disabled value="">
              <em>Decision</em>
            </MenuItem>

            <MenuItem value="Allow">Allow</MenuItem>
            <MenuItem value="Block">Block</MenuItem>
            <MenuItem value="Transform">Transform</MenuItem>
            <MenuItem value="Step Up">Step Up</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <Select
            displayEmpty
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem disabled value="">
              <em>Type</em>
            </MenuItem>

            <MenuItem value="Prompt">Prompt</MenuItem>
            <MenuItem value="Tool Call">Tool Call</MenuItem>
            <MenuItem value="Tool Result">Tool Result</MenuItem>
            <MenuItem value="Output">Output</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <Select
            displayEmpty
            value={server}
            onChange={(e) => setServer(e.target.value)}
          >
            <MenuItem disabled value="">
              <em>Server</em>
            </MenuItem>

            <MenuItem value="MCP Server">MCP Server</MenuItem>
            <MenuItem value="ACP Server">ACP Server</MenuItem>
          </Select>
        </FormControl>

        <AppFormikDatePicker
          disableToday
          autoFocus
          fullWidth
          name="startDate"
          testid="datepicker-dropdown"
          InputProps={{
            name: 'startDate',
            'aria-labelledby': 'duedate-label',
            notched: false,
          }}
          min
          placeholder="gg/mm/aaaa"
          renderInput={(props: any) => (
            <TextField {...props} fullWidth margin="normal" />
          )}
        />
        <AppFormikDatePicker
          disableToday
          autoFocus
          fullWidth
          name="endDate"
          testid="datepicker-dropdown"
          InputProps={{
            name: 'endDate',
            'aria-labelledby': 'duedate-label',
            notched: false,
          }}
          min
          placeholder="gg/mm/aaaa"
          renderInput={(props: any) => (
            <TextField {...props} fullWidth margin="normal" />
          )}
        />
        <AppPrimaryButtonOutlined title="Clear" className=" btn-small" />
      </Stack>

      <Box className="policy-audit-wrapper">
        <NoAuditCard />
      </Box>
    </>
  );
};

export default AuditLogFilterList;
